"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.711 10.86a.5.5 0 0 0-.5.5v1.28a.5.5 0 0 0 .5.5h.795a.5.5 0 0 0 .5-.5v-1.28a.5.5 0 0 0-.5-.5zm3.141 0a.5.5 0 0 0-.5.5v1.28a.5.5 0 0 0 .5.5h.795a.5.5 0 0 0 .5-.5v-1.28a.5.5 0 0 0-.5-.5zm-.5 4.15a.5.5 0 0 1 .5-.5h.795a.5.5 0 0 1 .5.5v1.28a.5.5 0 0 1-.5.5h-.795a.5.5 0 0 1-.5-.5zm-2.641-.5a.5.5 0 0 0-.5.5v1.28a.5.5 0 0 0 .5.5h.795a.5.5 0 0 0 .5-.5v-1.28a.5.5 0 0 0-.5-.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.803 5.701v1.95H19.3a1.7 1.7 0 0 1 1.7 1.7v8.948a1.7 1.7 0 0 1-1.7 1.7H4.7A1.7 1.7 0 0 1 3 18.3V5.701a1.7 1.7 0 0 1 1.7-1.7h5.403a1.7 1.7 0 0 1 1.7 1.7m-7.403 0a.3.3 0 0 1 .3-.3h2.068v2.25H4.4zm3.768 1.95V5.4h1.935a.3.3 0 0 1 .3.3v1.95zm0 1.4h2.235V11.3H8.168zm0 3.649h2.235v2.25H8.168zm0 3.65h2.235v2.25H8.168zm3.635 2.25H19.3a.3.3 0 0 0 .3-.3V9.35a.3.3 0 0 0-.3-.3h-7.497zm-5.035-2.25v2.25H4.7a.3.3 0 0 1-.3-.3v-1.95zm0-1.4H4.4V12.7h2.368zm0-3.65H4.4V9.05h2.368z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=OrganizationBuildingIcon24.js.map